/* ProjectLP — theme JS: mobile nav, cart count refresh after AJAX add */
(function () {
  'use strict';

  // Mobile nav toggle
  const toggle = document.querySelector('.mobile-nav-toggle');
  const nav = document.querySelector('.nav-split');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Refresh cart count on AJAX add events
  async function refreshCartCount() {
    try {
      const res = await fetch(window.theme.routes.cart + '.js', { headers: { 'Accept': 'application/json' } });
      const cart = await res.json();
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = '· ' + cart.item_count;
      });
    } catch (e) {}
  }
  document.addEventListener('cart:added', refreshCartCount);

  // Wire any non-configurator product forms to AJAX too (optional, gentle)
  document.querySelectorAll('[data-product-form]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      const submitBtn = form.querySelector('[type="submit"]');
      if (!submitBtn || submitBtn.disabled) return;
      // Allow the default native submit for now to preserve checkout flow on non-JS.
      // (To switch to AJAX, uncomment below.)
      // e.preventDefault();
      // const data = new FormData(form);
      // const items = { id: data.get('id'), quantity: 1 };
      // try { await fetch(window.theme.routes.cartAdd, { method:'POST', body: JSON.stringify({ items:[items] }), headers:{'Content-Type':'application/json'} }); document.dispatchEvent(new CustomEvent('cart:added')); window.location.href = window.theme.routes.cart; } catch(err) {}
    });
  });
})();
